import { store } from '~state/ReduxWrapper';

import { prepareDataForSubmit } from '~components/forms/SubmissionHelpers';
import updateDataLayer from '~utils/events';
import { navigate } from 'gatsby';
import sendEvent from '~actions';
import axios from '~utils/axios';
import { handleFuturevoterPostResult } from '~components/Futurevoter/navigateToSecondStep';
import updatePersonFields from '~actions/updatePersonFields';
import * as Sentry from '@sentry/gatsby';

export default function redirectToFutureVoter() {
  const { person, registerFields, sourcing } = store.getState();

  const params = prepareDataForSubmit({
    first_name: person.first_name,
    last_name: person.last_name,
    state: person.state,
    year_of_birth: person.year_of_birth,
    month_of_birth: person.month_of_birth,
    day_of_birth: person.day_of_birth,
    email: person.email,
    phone: person.phone,
    sms_opt_in_subscriber: registerFields.sms_opt_in_subscriber,
    sms_opt_in_voteamerica: registerFields.sms_opt_in_voteamerica,
    referring_tool: 'register',
  });

  sendEvent(registerFields.action_id, 'FinishRedirect', 'register');

  updateDataLayer({
    event: 'action-finish',
    method: 'redirect-to-futurevoter',
    tool: 'register',
    state: person.state,
    first_name: person.first_name,
    last_name: undefined,
    email: undefined,
    zipcode: person.zipcode,
    url: undefined,
  });

  updateDataLayer({
    event: 'action-start',
    method: undefined,
    tool: 'futurevoter',
    state: person.state,
    first_name: person.first_name,
    last_name: undefined,
    email: undefined,
    zipcode: person.zipcode,
    url: undefined,
  });

  axios
    .post(
      `futurevoter/start-registration/?incomplete=true&subscriber=${sourcing.subscriber}`,
      params
    )
    .then(({ data }) => {
      store.dispatch(updatePersonFields(params));
      handleFuturevoterPostResult(params, data, 'register');
    })
    .catch((error) => {
      /* eslint-disable-next-line no-console */
      console.warn(error?.response?.data ?? error);
      Sentry.captureException(error);

      // If something went wrong, just send them to the front page
      navigate('/tools/futurevoter/');
    });
}
